import React from "react";
import { AppList } from "components/list/AppList";
import { Datagrid,
    TextField,
 } from "react-admin";
import { DeleteButton } from "react-admin";

const UserManual = (props) => {
    return (
        <AppList {...props}
        bulkActionButtons={false}
        exporter={false}
        >
            <Datagrid>
                <TextField source="id" />
                <TextField source="page_url" sortable={false}/>
                <TextField source="locale"/>
                <DeleteButton />
            </Datagrid>
        </AppList>
    );
}

export default UserManual;